import axios from 'axios'

/**
 * Company entitlement, read straight from hcheck (`/web/company/entitlement`). The token is the same
 * one this front already holds — the auth server is shared and hcheck is a resource server — so no
 * extra credential is involved.
 *
 * Own axios call instead of `checklistApi`: that module captures the token at import time, which is
 * stale for the very first read right after login.
 */
export const fetchEntitlement = () => {
  const baseURL = process.env.VUE_APP_CHECKLIST_API_URL
  const token = localStorage.getItem('access_token')

  if (!baseURL || !token) return Promise.reject(new Error('Entitlement lookup not configured'))

  return axios.get(`${baseURL}/web/company/entitlement`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 4000,
  })
}
